/* eslint @typescript-eslint/naming-convention: 0 */

import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface ChangeCurrencyParams {
  currency: string;
  location: string;
}

/**
 * 発火タイミング：通貨変更実行時
 */
export const sendGAWabunkaChangeCurrencyEvent = (currency: string, location: string) => {
  sendWabunkaGAEvent('change_currency', { currency, location });
};
